export enum HorizontalDirection {
    RightToLeft = 'rtl',
    LeftToRight = 'ltr'
}
